import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import NotificationCenter from './NotificationCenter';

function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }
  return {
    title: 'Notifications | Admin',
    component: (
      <AdminLayout>
        <NotificationCenter />
      </AdminLayout>
    ),
  };
}

export default action;
